module.exports = __webpack_public_path__ + "img/index-text.png";